import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { _adr } from "./address";
import { useEffect } from "react";
import { checkToken, setToken } from "./tools/services";
import { useAPIPublic } from "./tools/api";
import ExternalRedirect from "./components/ExternalRedirect";

export const ScrollToTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
};

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path={_adr.Root + _adr.Packages + "/*"} element={<ExternalRedirect to="https://www.aptel.ir/packages" />} />
          <Route path={_adr.Root + _adr.DirectCharge + "/*"} element={<ExternalRedirect to="https://www.aptel.ir/charge" />} />
        </Routes>
        <ScrollToTop />
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
